import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Box,
  Button,
  Divider,
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Chip,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React, { useEffect, useRef, useState } from "react";
import SearchBox from "../../common/components/SearchBox";
import { connect } from "react-redux";
import {
  deleteVotingGroup,
  getVotingGroupUnits,
} from "../../../store/voting/actions";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";

const ViewGroupDialog = (props) => {
  const {
    loading,
    onWait,
    showGroupDialog,
    setShowGroupDialog,
    votingGroupUnits,
    user,
    getVotingGroupUnits,
    deleteVotingGroup,
    group,
    enableToDelete,
  } = props;
  const [searchTeam, setSearchTeam] = useState("");
  const [filteredUnits, setFilteredUnits] = useState([...votingGroupUnits]);
  const [confirmRemoveRequest, setConfirmRemoveRequest] = useState(false);
  const containerRef = useRef(null);
  const bottomRef = useRef(null);
  const [formData, setFormData] = useState({
    name: group?.name,
    openingDate: group?.openingDate,
    closingDate: group?.closingDate,
  });
  useEffect(() => {
    getVotingGroupUnits(group?.id);
  }, []);

  useEffect(() => {
    const filtered = [...votingGroupUnits].filter(({ unitName }) =>
      (unitName || "").toLowerCase().includes(searchTeam.toLowerCase())
    );

    setFilteredUnits(filtered);
  }, [searchTeam, votingGroupUnits]);

  const onSearchUnit = (term) => {
    setSearchTeam(term);
  };
  const onClose = () => {
    setFormData({
      name: "",
      openingDate: null,
      closingDate: null,
      unitIds: [],
    });
    setShowGroupDialog(false);
  };

  return (
    <>
      <Dialog
        // onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showGroupDialog}
        fullWidth
        maxWidth={"md"}
      >
        <DialogTitle className="text-primary">
          <Typography
            variant="overline"
            className="text-truncate"
            display="block"
            style={{ maxWidth: "70%" }}
          >
            <div className="headerorg mb-0">
              <div className="header_cont">
                <span className="ml-0 text-dark">
                  View Group | {group?.name}
                </span>
              </div>
            </div>
          </Typography>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%", minHeight: "60vh" }}>
            <div>
              <div style={{ padding: "0.25rem 1.2rem" }}>
                <div className="form-group1 mb-2">
                  <div className="row">
                    <div className="col-lg-12 mb-1">
                      <TextField
                        fullWidth
                        autoFocus
                        size="small"
                        rows={4}
                        name="name"
                        label="Name"
                        variant="outlined"
                        value={formData.name}
                        readOnly={true}
                      />
                    </div>
                    <div className="col-lg-6 mt-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          label="Opening Date"
                          inputFormat="MM/dd/yyyy"
                          value={formData.openingDate}
                          readOnly={true}
                          renderInput={(params) => (
                            <TextField size="small" fullWidth {...params} />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                    <div className="col-lg-6 mt-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          label="Closing Date"
                          inputFormat="MM/dd/yyyy"
                          disabled={!formData.openingDate}
                          readOnly={true}
                          value={formData.closingDate}
                          renderInput={(params) => (
                            <TextField size="small" fullWidth {...params} />
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row w-100 mt-2 ml-1" ref={containerRef}>
                <div className="col-12">
                  <div className="card service-card valid mb-2 mt-1 w-100">
                    <div
                      className="card-header"
                      style={{ padding: "0.25rem 1.2rem" }}
                    >
                      Group Unit(s)
                    </div>
                    <div className="card-body">
                      <div className="px-2 pt-2">
                        <SearchBox
                          disabled={!votingGroupUnits.length}
                          onSearch={onSearchUnit}
                          placeholder="Search unit(s) ..."
                        />
                      </div>
                      <List
                        sx={{
                          width: "100%",
                          bgcolor: "background.paper",
                          maxHeight: "400px",
                          overflowY: "auto",
                        }}
                      >
                        {filteredUnits.map(
                          ({ unitName, isOnStructure, unitId }) => {
                            const labelId = `checkbox-list-label-${unitId}`;

                            return (
                              <>
                                <ListItem
                                  key={unitId}
                                  disablePadding
                                  style={{
                                    backgroundColor: `${"#e9ecef"}`,
                                  }}
                                >
                                  <ListItemButton role={undefined} dense>
                                    <ListItemIcon>
                                      <Checkbox
                                        edge="start"
                                        checked={true}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{
                                          "aria-labelledby": labelId,
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      id={labelId}
                                      primary={unitName}
                                      secondary={
                                        <strong
                                          className={`d-flex align-items-center text-dark text-uppercase `}
                                          style={{
                                            cursor: "default",
                                            borderRadius: "8px",
                                            fontSize: "10px",
                                          }}
                                        >
                                          {!isOnStructure && (
                                            <Chip
                                              style={{ borderRadius: "0px" }}
                                              className="ml-1 small-chip"
                                              label="Not on structure"
                                              color="error"
                                              size="small"
                                              variant="outlined"
                                            />
                                          )}
                                        </strong>
                                      }
                                    />
                                  </ListItemButton>
                                </ListItem>
                                <Divider />
                              </>
                            );
                          }
                        )}
                      </List>
                    </div>
                  </div>
                </div>

                <div ref={bottomRef}></div>
              </div>
            </div>
          </Box>
        </DialogContent>
        {enableToDelete && (
          <DialogActions className="d-flex justify-content-center pb-3">
            {confirmRemoveRequest && (
              <ConfirmationDialog
                confirmationDialog={confirmRemoveRequest}
                message={`Are you sure you want to remove this group @ ${group.name}?`}
                setConfirmationDialog={setConfirmRemoveRequest}
                onYes={() => {
                  deleteVotingGroup(group, setConfirmRemoveRequest);
                }}
              />
            )}
            <Button
              disabled={loading || onWait}
              onClick={() => setConfirmRemoveRequest(true)}
              color={"error"}
              variant="contained"
              size="md"
            >
              {onWait ? "Wait.." : <>Delete</>}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};

const mapStateToProps = ({ loading, onWait, user, votingGroupUnits }) => {
  return {
    loading,
    onWait,
    user,
    votingGroupUnits,
  };
};
export default connect(mapStateToProps, {
  getVotingGroupUnits,
  deleteVotingGroup,
})(ViewGroupDialog);
